import moment from 'moment/moment';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Row, Typography } from 'antd';

import { EmptyComponent, MarkDot, Pagination } from 'componets/ui';
import { NewsSearch } from './NewsSearch';

import { useAppDispatch, useAppSelector } from 'hooks';

import { getNews } from 'features/news/actions';

import { language } from 'utils';
import { Paths, PAGE_SIZE } from 'utils/constants';
import Utils from 'utils/utils';

import styles from './index.module.scss';
import { ReadAllNews } from './ReadAllNews';

export const News = () => {
	const [highlight, setHighlight] = useState('');
	const navigate = useNavigate();

	const [searchParams] = useSearchParams();
	const searchPage = searchParams.get('page');

	const [page, setPage] = useState(searchPage || 1);
	const dispatch = useAppDispatch();

	const { news, pager } = useAppSelector((state) => state.news);

	useEffect(() => {
		dispatch(
			getNews({
				lang: language,
				params: { pageSize: PAGE_SIZE, offset: page === 1 ? 0 : +page * PAGE_SIZE - PAGE_SIZE },
			}),
		);
	}, [dispatch, page]);

	return (
		<div className={styles.root}>
			<div className={styles.searchRow}>
				<NewsSearch onSubmit={setHighlight} />

				<ReadAllNews />
			</div>

			<div className={styles.items}>
				{news.length === 0 ? (
					<EmptyComponent />
				) : (
					news.map((item) => {
						return (
							<Link
								key={item.id}
								to={Paths.PIECE_OF_NEWS(item.id)}
								className={styles.item}
								state={{ page }}
							>
								<Row className={styles.row}>
									<Typography.Text type="secondary">
										{moment(item.publishedAt).format('YYYY-MM-DD')}
									</Typography.Text>

									<MarkDot item={item} />
								</Row>

								<div>
									<div>
										<span className={styles.newsTitle}>
											{Utils.getHighlightedText(item.title, highlight)}
										</span>
									</div>

									<div>{Utils.getHighlightedText(item.preview, highlight)}</div>
								</div>
							</Link>
						);
					})
				)}
			</div>

			{Math.ceil(pager.totalCount / PAGE_SIZE) > 1 && (
				<Pagination
					total={pager.totalCount}
					onChange={(page: number) => {
						setPage(page);
						navigate({
							pathname: Paths.NEWS,
							search: `?page=${page}`,
						});
					}}
					current={+page}
				/>
			)}
		</div>
	);
};
